import { render } from "./CommonButton.vue?vue&type=template&id=e775761a&scoped=true&ts=true"
import script from "./CommonButton.vue?vue&type=script&lang=ts"
export * from "./CommonButton.vue?vue&type=script&lang=ts"

import "./CommonButton.vue?vue&type=style&index=0&id=e775761a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e775761a"]])

export default __exports__